import { Controller } from "@hotwired/stimulus"
import $ from "jquery"

import autocomplete from "lib/autocomplete"
import AcademicTitles from "lib/academic_titles"

// Suggests academic job titles in a free-text field. lib/autocomplete has no
// teardown (each call adds a menu and a document listener), so an input is
// only set up once, even if the controller reconnects.
export default class extends Controller {
  connect() {
    const input = $(this.element)
    if (input.data("autocomplete")) return

    autocomplete(input, {
      source: AcademicTitles.list,
      minLength: 2,
      autoFocus: true,
      delay: 200,
      select(event, ui) {
        return this.val(ui.item)
      },
    })
  }
}
